// extracted by mini-css-extract-plugin
export default {"gridCustomWidth":"BaseForm_gridCustomWidth__tCuuj"};